// extracted by mini-css-extract-plugin
export default {"KemuSwitch":"KemuSwitch_KemuSwitch__HVy5U"};